import type { FC } from 'react';
import React, { useState, useEffect, useCallback } from 'react';
import cn from 'classnames';
import { sendEvent } from '@alfa-bank/site-helpers-common/browser/send-event';

import type { TDesktop } from '../models/desktop';
import { getDeliveryDay } from '../helpers/get-delivery-day';
import { parseArrayLines } from '../helpers/parse-array-lines';
import type { TButtonOnClick } from '../models';

export const BannerButton: FC<TDesktop> = ({
    Button,
    Case,
    Grid,
    IconShortArrow,
    Switch,
    Text,
    Timer,
    button,
    onEventPublish,
    styles,
    theme,
    timer,
}) => {
    const arrowColor = theme === 'blue' ? '#fff' : '#000';
    const [isHidden, setIsHidden] = useState<boolean>(true);
    const [visibleElem, setVisibleElem] = useState<string>(getDeliveryDay(timer?.breakpoint));

    useEffect(() => {
        if (typeof window !== 'undefined' && isHidden) {
            setIsHidden(false);
        }
    }, [isHidden]);

    const buttonOnClick: TButtonOnClick = useCallback(
        e => {
            if (onEventPublish) {
                onEventPublish(e);
            }
            if (button?.event) {
                sendEvent(button?.event);
            }
        },
        [button?.event, onEventPublish]
    );

    if (!button) return null;

    return (
        <Grid
            alignment="center"
            className={cn(styles.external, styles.buttonBlock)}
            colAutoWidth
            collapse
            justify="start"
        >
            <Button href={button.href} onClick={buttonOnClick} view="primary">
                {button.text}
            </Button>
            {timer && (
                <div
                    className={cn(styles.timerBlock, {
                        [styles.blockHidden]: isHidden,
                    })}
                >
                    <Text size="s" Tag="div" theme={theme}>
                        <IconShortArrow
                            className={cn(styles.external, styles.buttonArrow)}
                            color={arrowColor}
                            height={11}
                            width={7}
                        />
                        <Switch visible={visibleElem}>
                            <Case id="today">
                                {parseArrayLines(timer.todayText)}{' '}
                                <Timer
                                    breakPoint={timer.breakpoint}
                                    onStart={
                                        /* istanbul ignore next */ () => setVisibleElem('today')
                                    }
                                    onStop={
                                        /* istanbul ignore next */ () => setVisibleElem('tomorrow')
                                    }
                                />
                            </Case>
                            <Case id="tomorrow">{parseArrayLines(timer.tomorrowText)}</Case>
                        </Switch>
                    </Text>
                </div>
            )}
        </Grid>
    );
};
